import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild, inject, OnDestroy } from '@angular/core'
import { BehaviorSubject, Subscription } from 'rxjs'

@Component({
  selector: 'jml-lib-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements AfterViewInit, OnDestroy {
  /**
   * Show or hide the overlay.
   */
  @Input() set visible(value: boolean) {
    this.visibleSubject.next(value)
  }

  /**
   * Pass a css class in which will be aplied to the overlay.
   * Especially usefull to apply  template classes for padding, e.g. p-1.
   */
  @Input() overlayCssClass: string | undefined = undefined

  /**
   * Specifies the width of the overlay in pixel.
   * The default is 100.
   */
  @Input() widthPx = 100

  /**
   * Reference of the element to which the overlay should be appended.
   * If nothing is provided it is natively appended to its parent.
   */
  @Input() appendTo: ElementRef | undefined = undefined

  @ViewChild('myOverlay') overlay!: ElementRef
  overlayEl: HTMLElement | undefined = undefined

  private renderer = inject(Renderer2)

  private visibleSubject = new BehaviorSubject<boolean>(false)
  visible$ = this.visibleSubject.asObservable()
  private visibilityChangeSubscription!: Subscription

  ngAfterViewInit() {
    this.overlayEl = this.overlay.nativeElement

    // Subscribe to the visibility changes
    this.visibilityChangeSubscription = this.visible$.subscribe((isVisible) => (isVisible ? this.show() : this.hide()))
  }

  show() {
    // If appendTo is an ElementRef, append to that element
    if (!!this.appendTo) {
      if (this.appendTo instanceof ElementRef) {
        this.renderer.appendChild(this.appendTo.nativeElement, this.overlayEl)
      } else {
        console.error(`Provided input value for 'appendTo' ${this.appendTo} is invalid.`)
      }
    }

    this.renderer.setStyle(this.overlayEl, 'display', 'block')
    this.renderer.setStyle(this.overlayEl, 'width', `${this.widthPx}px`)
  }

  private hide() {
    setTimeout(() => {
      // timeout is crucial to allow both flags to be modified meanwhile. Without, timeout it will not work.
      this.renderer.setStyle(this.overlayEl, 'display', 'none')
      this.renderer.removeChild(document.body, this.overlayEl)
    }, 100)
  }

  ngOnDestroy(): void {
    this.visibilityChangeSubscription.unsubscribe()
    this.hide()
  }
}
